import options from './layout.component';

export default {
    selector: 'dtLayout',
    options
};
